import isObject from 'lodash/isObject'
import cloneDeep from 'lodash/cloneDeep'

const DEFAULT_DURATION = 200
function isOptionDisabled (option) {
  return isObject(option) && option.disabled
}

function range (num, min, max) {
  return Math.min(Math.max(num, min), max)
}

export default {
  props: {
    itemHeight: [Number, String],
    valueKey: String,
    allowHtml: Boolean,
    className: String,
    defaultIndex: Number,
    visibleItemCount: [Number, String],
    initialOptions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentIndex: this.defaultIndex,
      options: cloneDeep(this.initialOptions),
      duration: 0
    }
  },
  watch: {
    initialOptions: 'setOptions',
    defaultIndex (val) {
      this.setIndex(val)
    }
  },
  computed: {
    count () {
      return this.options.length
    },
    baseOffset () {
      return (this.itemHeight * (this.visibleItemCount - 1)) / 2
    }
  },
  render () {
    const wrapperStyle = {
      transform: `translate3d(0, ${this.offset + this.baseOffset}px, 0)`,
      transitionDuration: `${this.duration}ms`,
      transitionProperty: this.duration ? 'all' : 'none',
      lineHeight: `${this.itemHeight}px`
    }

    return (
      <div class={['picker-column', this.className]}>
        <ul
          ref="wrapper"
          style={wrapperStyle}
          class="picker-column__wrapper" // todo bem function
          onTransitionend={this.onTransitionEnd}
        >
          {this.genOptions()}
        </ul>
      </div>
    )
  },
  methods: {
    genOptions () {
      const optionStyle = {
        height: `${this.itemHeight}px`
      }

      return this.options.map((option, index) => {
        const text = this.genOptionText(option)
        const disabled = isOptionDisabled(option)

        const data = {
          style: optionStyle,
          attrs: {
            role: 'button',
            tabindex: disabled ? -1 : 0
          },
          class: [
            'ellipsis',
            {
              disabled,
              selected: index === this.currentIndex
            }
          ],
          on: {
            click: () => {
              this.onClickItem(index)
            }
          }
        }

        if (this.allowHtml) {
          data.domProps = {
            innerHTML: text
          }
        }

        return <li {...data}>{this.allowHtml ? '' : text}</li>
      })
    },
    genOptionText (option) {
      if (isObject(option) && this.valueKey in option) {
        return option[this.valueKey]
      }
      return option
    },
    onClickItem (index) {
      if (this.moving) return

      this.duration = DEFAULT_DURATION
      this.setIndex(index, true)
    },
    setIndex (index, emitChange) {
      index = this.adjustIndex(index) || 0

      const offset = -index * this.itemHeight

      const trigger = () => {
        if (index !== this.currentIndex) {
          this.currentIndex = index

          if (emitChange) this.$emit('change', index)
        }
      }

      if (this.moving && offset !== this.offset) {
        this.transitionEndTrigger = trigger
      } else {
        trigger()
      }

      this.offset = offset
    },
    adjustIndex (index) {
      index = range(index, 0, this.count)

      for (let i = index; i < this.count; i++) {
        if (!isOptionDisabled(this.options[i])) return i
      }

      for (let i = index - 1; i >= 0; i--) {
        if (!isOptionDisabled(this.option[i])) return i
      }
    },
    onTransitionEnd () {}
  }
}
